type Props = {
  title: string;
  description: string;
  module: string;
};

export function ModulePlaceholderPage({ title, description, module }: Props) {
  return (
    <div className="space-y-4">
      <header>
        <p className="text-xs font-semibold uppercase tracking-wide text-brand-600">{module}</p>
        <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
        <p className="mt-2 max-w-2xl text-sm text-slate-600">{description}</p>
      </header>
      <div className="rounded-xl border border-dashed border-slate-300 bg-white p-8 text-center">
        <p className="text-sm text-slate-500">
          Module shell integrated into Alpha navigation. Backend service APIs available via platform gateway.
        </p>
      </div>
    </div>
  );
}
